// extracted by extract-css-chunks-webpack-plugin
module.exports = {"welfare":"welfare_Oz6a6"};